import WX from '../environment/weixin_api.js'
import DefaultApi from '../environment/default_api.js'
// import TxhAppApi from '../environment/txh_api.js'
import JSJAppApi from '../environment/jsj_api.js'
import WxMiniApi from '../environment/weixinMini_api.js'
import useApi from '../api/user.js'
var provider = null
var _entrance = window.entrance
if (_entrance.name === 'wx') {
  provider = WX
} else if (_entrance.name === 'jsj') {
  provider = JSJAppApi
} else if (_entrance.name === 'WxMini') {
  provider = WxMiniApi
} else {
  provider = DefaultApi
  console.log(_entrance.name, 'use DefaultApi')
}
const Environment = {
  // 分享
  share: function (option, successcb, errorcb) {
    successcb =
      successcb ||
      function (data) {
        console.log('---->', data)
      }
    errorcb =
      errorcb ||
    function (data) {
      console.log('---->', data)
      }
    provider.share(option, successcb, errorcb)
  },
  shareClick: function (option) {
    provider.shareClick(option)
  },
  // 关闭
  close: function (successcb, errorcb) {
    var options = {}
    provider.close(options, successcb, errorcb)
  },

  /// 浏览器打开
  openBrowser: function (url, successcb, errorcb) {
    var options = { uri: url }
    provider.openBrowser(options, successcb, errorcb)
  },

  // 上传图片
  upload: function (localId, successcb, errorcb) {
    var options = {
      localId: localId,
      imageW: 3036,
      imageH: 4048,
      maxCertImg: 512000,
      quality: 90,
      imgCount: 1
    }
    errorcb =
      errorcb ||
      function (data) {
        console.log(data)
      }
    var onSuccess = function (data) {
      if (!data) {
        errorcb('没有选择任何图片')
      }
      successcb(data)
    }
    provider.uploadImg(options, onSuccess)
  },
  // 选择图片
  chooseImage: function (successcb, errorcb) {
    var options = {
      imageW: 3036,
      imageH: 4048,
      maxCertImg: 512000,
      quality: 90,
      imgCount: 1
    }
    errorcb =
      errorcb ||
      function (data) {
        console.log(data)
      }
    var onSuccess = function (data) {
      if (!data) {
        errorcb('没有选择任何图片')
      }
      successcb(data)
    }
    provider.chooseImage(options, onSuccess, errorcb)
  },
  // 获取定位信息
  getLocationInfo() {
    return useApi.getInitCityInfo()
  },
  // 同步定位信息
  getSyncCity(nowCityId) {
    provider.getSyncCity(nowCityId)
  },
  // 更新定位信息
  updatecity(item) {
    provider.updatecity(item)
  }
}
export default Environment



// WEBPACK FOOTER //
// ./src/service/environment.service.js